module.exports = __webpack_public_path__ + "static/media/add-user.28872bd6.svg";